
/* ELEMENTS*/
  var 
    $themeDoc=jQuery(document),
    $themeWin=jQuery(window),
    $themeBody=jQuery("body"),
    $themeHtmlBody=jQuery("html, body"),
    $themeHtml=jQuery("html"),
    $themeMain=$themeBody.find('main.main'),
    $themeStripBar = jQuery('#strip-bar'),
    $themeStripBarFixed = jQuery('#strip-bar.strip-bar--position-fixed'),
    $themeStripBarSingle = jQuery('#strip-bar.strip-bar--single');

/* COMMON VARS */
var
  themeDocTop = 0,
  post_info = [],
  post_already_showed = [],
  feed_urls = [],
  $post_view = false,
  post_showed = 0,
  post_viewing=0,
  singleOffsetTop = 0,
  singleOffsetBottom = 0,
  is_scrolling_to = false,
  is_scrolling_to_next_post = false,
  is_scrolling_to_prev_post = false,
  position_load_pagination = false,
  position_load_feed = false,
  position_load_next_post = false,
  real_document_title = null,
  // is_changed_article = false,
  // appending_article = false,
  aspectRatio = 9 / 16,
  mobile_breakpoint = 736,
  container_width = 996,
  related_position = 0;
  // window.box_viewable = false;


/* VAR USED COMMON.JS */
 var 
    $headerTheme = jQuery('.header--theme'), 
    theme_min_menu_appear = -1,  
    themeDocTopOld = 0, 
    themeDocTopFixed = 0,
    themeDocTopSaved=0;

/* VAR USED SINGLE.JS */
var get_post_info = false,
    get_post_info_ajax = false,
    failed = 0,
    get_feed_posts_info_ajax = false,
    viewing_text = null,
    post_pagination_end = [],
    appending_pagination = [],
    read_more_opened = [];


var THEME = {};
